const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: '-52px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  uploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '52px',
    width: 'fit-content',
    position: 'relative',
    zIndex: 1,
  },
  boxDelete: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
  },
  boxDelete: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
  },
  deleteTitle: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
    marginLeft: '8px',
  },
  deleteButton: {
    '& hover': {
      color: 'var(--Error, #ED4245)',
    },
  },
  uploadBox: {
    width: '174px',
    height: '100px',
    background: '#F9FAFB',
    border: '1px dashed #E5E7EB',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: '#F3F4F6',
    },
  },
  plusIcon: {
    fontSize: '24px',
    color: '#9CA3AF',
  },
  imagePreview: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
  },
  iconButton: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  uploadBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
  },
  thumbnailView: {
    width: '174px',
    height: '100px',
    borderRadius: '12px',
    position: 'relative',
    display: 'flex',
  },
})

export default styles
